package com.bikompanion.data.gbfs

import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsStationInformationData(
    val stations: List<GbfsStationInformationDto>,
)
